import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUser, hasOAuthHashSession, isAuthenticated } from '@/lib/apiService';
import {
  canAccessDashboardPath,
  getDefaultAuthenticatedRoute,
} from '@/lib/accessControl';
import { CONSENT_REQUIRED_ROUTE, readConsentGateState } from '@/lib/consentGate';
import { isDemoModeEnabled } from '@/demo/config';
interface DashboardAccessGuardProps {
  children: React.ReactNode;
}

export const DashboardAccessGuard: React.FC<DashboardAccessGuardProps> = ({ children }) => {
  const location = useLocation();
  const user = getCurrentUser();
  const isDemoMode = isDemoModeEnabled();

  if (isDemoMode) {
    return <>{children}</>;
  }

  if (hasOAuthHashSession()) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 animate-spin rounded-full border-b-2 border-primary" />
          <p className="mt-4 text-gray-600">Signing you in...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated() || !user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  if (readConsentGateState()?.accessBlocked) {
    return <Navigate to={CONSENT_REQUIRED_ROUTE} replace />;
  }

  if (!canAccessDashboardPath(location.pathname, user)) {
    return <Navigate to={getDefaultAuthenticatedRoute(user)} replace />;
  }

  return <>{children}</>;
};
